import {ProductImage as ProductImageType} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product_images.types';
import {useTranslation} from '@aboutyou/i18n';
import {useCanGoBackCallback, useHistory} from '@aboutyou/router';
import {BackButton, COLORS, ProductImage, Text} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {useMemo} from 'react';
import {ShareButton} from '../ProductSlider/CTAs/ShareButton';

export const SoldOutState = (props: {
  productImage: ProductImageType;
  productName: string;
  brandName: string;
  shareUrl: string;
}) => {
  const {t} = useTranslation();
  const {productImage, productName, brandName} = props;
  const canGoBackCallback = useCanGoBackCallback();
  const canGoBack = useMemo(() => canGoBackCallback(), []);
  const {goBack} = useHistory();

  const handleGoBack = () => {
    if (canGoBack) {
      goBack();
    }
  };

  return (
    <>
      <Wrapper>
        <ImageWrapper>
          <SoldOutImage
            src={productImage.src}
            loading="eager"
            alt={t('Sold Out Product Image')}
          />
        </ImageWrapper>
        <ImageText>
          <CTAContainer data-justifyend={!canGoBack}>
            {canGoBack && <StyledBackButton onClick={handleGoBack} />}
            <StyledShareButton iconColor={COLORS.White} url={props.shareUrl} />
          </CTAContainer>

          <Text size="px10" weight="bold" color="White">
            {t('Unfortunately sold out')}
          </Text>
          <Text size="px32" color="White">
            {t('Sold Out')}
          </Text>
        </ImageText>
      </Wrapper>

      <NameAndBrandWrapper>
        <BrandName size="px12" weight="bold">
          {brandName}
        </BrandName>
        <Text size="px10">{productName}</Text>
      </NameAndBrandWrapper>
    </>
  );
};

const CTAContainer = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  justify-content: space-between;
  width: 100%;

  &[data-justifyend='true'] {
    justify-content: flex-end;
  }
`;

const StyledBackButton = styled(BackButton)`
  &&& {
    z-index: 2;

    svg {
      fill: ${COLORS.White};
    }
  }
`;

const StyledShareButton = styled(ShareButton)`
  z-index: 2;
`;

const BrandName = styled(Text)`
  line-height: 1.125rem; /* 150% */
  letter-spacing: 0.03rem;
  text-transform: uppercase;
`;

const SoldOutImage = styled(ProductImage)`
  & img {
    object-fit: contain;
  }
`;

const NameAndBrandWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem 1rem 0.5rem 1rem;
  align-items: center;
  justify-content: center;
`;

const Wrapper = styled.div`
  &:after {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    background: rgba(0, 0, 0, 0.4); // black with 50% opacity
  }
  background-color: ${COLORS.ProductImageBackground};
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding: 1rem 2rem;
`;

const ImageText = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  z-index: 2;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const ImageWrapper = styled.div`
  width: 200px;
`;
